// extracted by mini-css-extract-plugin
module.exports = {"container":"PageEntityEditor_container__2X1iU"};